/* ============================================================
   TCCC motion

   Reveal on scroll. One IntersectionObserver adds .tccc-vis to
   .tccc-rv, .tccc-stag and .tccc-dotrule, and the CSS transitions
   in tccc-tokens.css do the rest.

   Two rules this file must never break:

   1. Content is never hidden unless this script is alive. The
      hidden state lives behind html.tccc-motion, which is added by
      a small inline script in theme.liquid. If scripting fails the
      page simply renders, fully visible and static.

   2. If the observer never delivers (a backgrounded tab, a restored
      bfcache page, an old engine), a fallback reveals everything.
      Nothing may be left stranded at opacity zero.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '.tccc-rv, .tccc-stag, .tccc-dotrule';
  var FALLBACK_MS = 2500;

  var observer = null;
  var delivered = false;

  function reveal(el) {
    if (el && !el.classList.contains('tccc-vis')) el.classList.add('tccc-vis');
  }

  function revealAll(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) reveal(nodes[i]);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Someone who asked for less motion still gets the content, immediately.
  if (reducedMotion() || !('IntersectionObserver' in window)) {
    ready(function () { revealAll(); });
    return;
  }

  observer = new IntersectionObserver(function (entries) {
    delivered = true;
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        reveal(entries[i].target);
        observer.unobserve(entries[i].target);
      }
    }
  }, { threshold: 0.12 });

  function observe(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].classList.contains('tccc-vis')) observer.observe(nodes[i]);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    observe();

    // Safety net. A tab that was never painted (opened in the
    // background, or a preview frame) does not run observer
    // callbacks, which would otherwise leave the page blank.
    window.setTimeout(function () {
      if (!delivered) revealAll();
    }, FALLBACK_MS);
  });

  // Coming back to a backgrounded tab: catch anything the observer
  // could not report while the page was hidden.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !delivered) revealAll();
  });

  // Restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) revealAll();
  });

  // Shopify theme editor: re-scan re-rendered sections, and show the
  // section being edited straight away so it never looks broken.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    window.setTimeout(function () { revealAll(e.target); }, FALLBACK_MS);
  });
  document.addEventListener('shopify:section:select', function (e) {
    revealAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    revealAll(e.target);
  });
})();
